import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cross',
  templateUrl: './cross.component.html',
  styleUrls: ['./cross.component.scss']
})
export class CrossComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
